var exports = {
  "ij": "xe533113f--5ef8fe--skeleton-infrastructure",
  "Tj": "xe533113f--5ef8fe--map",
  "Io": "xe533113f--5ef8fe--distance",
  "LZ": "xe533113f--5ef8fe--categories",
  "L1": "xe533113f--5ef8fe--category",
};

module.exports = exports;
